import { BrowserRouter, Switch, Route } from "react-router-dom";
import * as ROUTES from "./constants/routes";

import {
  InitializationPage,
  OnboardingPage,
  ChooseSupervisorTypePage,
  BusinessRegistrationPage,
  PersonRegistrationPage,
  DataPrivacyPage,
} from "./pages";

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path={ROUTES.INITIALIZATION}
          component={InitializationPage}
        />
        <Route exact path={ROUTES.ONBOARDING} component={OnboardingPage} />
        <Route
          exact
          path={ROUTES.CHOOSE_SUPERVISOR_TYPE}
          component={ChooseSupervisorTypePage}
        />
        <Route
          exact
          path={ROUTES.BUSINESS_REGISTRATION}
          component={BusinessRegistrationPage}
        />
        <Route
          exact
          path={ROUTES.PERSON_REGISTRATION}
          component={PersonRegistrationPage}
        />
        <Route exact path={ROUTES.DATA_PRIVACY} component={DataPrivacyPage} />
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
